<template>
  <div class="product-block__container">
    <div class="order-group">
      <div v-if="true" class="order-group__quantity">
        <button v-if="false" class="button-v2 button-v2_transparent-1 button-v2_medium">
          <div class="button-v2__inner">
            <div class="button-v2__icon-box">
              <svg preserveAspectRatio="none" viewBox="0 0 32 32" fill="none" class="button-v2__icon"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15H11v2h10v-2z"/>
              </svg>
            </div>
          </div>
        </button>
        <input v-if="false" type="text" class="order-group__quantity-input" value="1"/>
        <button v-if="false" class="button-v2 button-v2_transparent-1 button-v2_medium">
          <div class="button-v2__inner">
            <div class="button-v2__icon-box">
              <svg preserveAspectRatio="none" viewBox="0 0 32 32" fill="none" class="button-v2__icon"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M15 15v-4h2v4h4v2h-4v4h-2v-4h-4v-2h4z"/>
              </svg>
            </div>
          </div>
        </button>
      </div>
      <div v-if="true" class="order-group__add-to-cart" @click="open_form" id="get_price_from_product_card">
        <div class="button-v2 button-v2_colored-1 button-v2_medium">
          <div class="button-v2__inner">
            Получить прайс
          </div>
        </div>
      </div>
      <div class="order-group__price-notification desk">
        <strong>Указана рекомендованная розничная цена</strong><br>
        <span>Размер скидки при оптовых поставках и комплектации объектов рассчитываем в индивидуальном порядке.</span>
      </div>
    </div>
  </div>
  <div class="product-block__container mob-only">
    <div class="order-group__price-notification mob">
      <strong>Указана рекомендованная розничная цена</strong><br>
      <span>Размер скидки при оптовых поставках и комплектации объектов рассчитываем в индивидуальном порядке.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductOrderBlock",
  computed: {
    // this_mobile: this.ppJs.popup_catalog.mobile,
  },
  mounted() {

  },
  methods: {
    open_form() {
      document.getElementById('header-feedback-button').click()
    }
  },
}
</script>

<style scoped>

</style>